module.exports = __webpack_public_path__ + "static/media/whatsapp2.656df3d8.png";